import { useEffect } from "react";
import { useLocation } from "react-router";

/**
 * 画面の題名と、共有・検索に載せる URL を今の画面に合わせる。
 *
 * <b>外枠（app.html）は 1 枚</b>なので、書き出した時点の canonical はどの画面でも同じになる。
 * 画面を移るたびに直さないと、検索エンジンに<b>別の画面の URL</b>を教える。
 * 形は書き出した静的な画面の題名と同じ（「題名 - Pleasanter.net」。<c>SiteApp/layout/site-head.tsx</c>）。
 */
export const usePageMeta = (title: string): void => {
    const { pathname } = useLocation();

    useEffect(() => {
        document.title = `${title} - Pleasanter.net`;

        const canonical = document.querySelector<HTMLLinkElement>("link[rel=canonical]");
        if (canonical !== null) {
            // 起点（https://pleasanter.net）は書き出したときの値をそのまま使う
            canonical.href = new URL(pathname, canonical.href).href;
        }
        const ogUrl = document.querySelector<HTMLMetaElement>("meta[property='og:url']");
        if (ogUrl !== null && canonical !== null) {
            ogUrl.content = canonical.href;
        }
    }, [title, pathname]);
};
